export const isHexColor = value => typeof value === 'string' && /^#[\da-f]{3}(?:[\da-f]{3})?$/i.test(value);

export const NODE_APPEARANCE_DEFAULTS = Object.freeze({ strokeWidth: 1, borderStyle: 'solid', headerStyle: 'bar', radius: 10 });
const borders = ['solid', 'dashed', 'dotted', 'none'];
const headers = ['bar', 'plain'];
const palettes = {
  neutral: { fill: '#f1f3f7', stroke: '#d1d6e1' },
  slate: { fill: '#f1f3f7', stroke: '#d1d6e1' },
  blue: { fill: '#f1f5fb', stroke: '#c8d4e4' },
  violet: { fill: '#f2edff', stroke: '#d3c5ef' },
  orange: { fill: '#fff7ed', stroke: '#fb923c' }
};

export function normalizeNodeAppearance(node) {
  for (const [key, value] of Object.entries(NODE_APPEARANCE_DEFAULTS)) if (node[key] === undefined) node[key] = value;
  if (typeof node.strokeWidth !== 'number' || !Number.isFinite(node.strokeWidth) || node.strokeWidth < 0 || node.strokeWidth > 8) throw new Error('边框粗细必须为 0 到 8 之间的有效数字。');
  if (!borders.includes(node.borderStyle)) throw new Error('边框样式必须为实线、虚线、点线或无边框。');
  if (!headers.includes(node.headerStyle)) throw new Error('区域标题样式必须为标题栏或普通标题。');
  if (typeof node.radius !== 'number' || !Number.isFinite(node.radius) || node.radius < 0 || node.radius > 40) throw new Error('圆角必须为 0 到 40 之间的有效数字。');
  // Legacy draw.io paint values were optional and ignored unless safe. Preserve
  // that behavior while removing unsafe values from the canonical document.
  for (const key of ['fillColor', 'strokeColor', 'fontColor']) if (node[key] != null && !isHexColor(node[key])) delete node[key];
  return node;
}

/** Resolved light-theme values shared by the DOM editor and file exporters. */
export function getNodeAppearance(node = {}) {
  const container = node.type === 'container';
  const palette = Object.prototype.hasOwnProperty.call(palettes, node.color) ? palettes[node.color] : palettes.blue;
  return {
    fill: isHexColor(node.fillColor) ? node.fillColor : container ? palette.fill : '#ffffff',
    stroke: isHexColor(node.strokeColor) ? node.strokeColor : container ? palette.stroke : '#e5e8f0',
    font: isHexColor(node.fontColor) ? node.fontColor : '#263042',
    iconColor: container || node.color === 'blue' ? '#4778bd' : node.color === 'orange' ? '#b77739' : '#7058df',
    iconBackground: node.color === 'blue' ? '#edf3ff' : node.color === 'orange' ? '#fff1e6' : '#f0ecff',
    strokeWidth: typeof node.strokeWidth === 'number' && Number.isFinite(node.strokeWidth) && node.strokeWidth >= 0 && node.strokeWidth <= 8 ? node.strokeWidth : 1,
    borderStyle: borders.includes(node.borderStyle) ? node.borderStyle : 'solid',
    headerStyle: headers.includes(node.headerStyle) ? node.headerStyle : 'bar',
    radius: typeof node.radius === 'number' && Number.isFinite(node.radius) && node.radius >= 0 && node.radius <= 40 ? node.radius : 10
  };
}
